<template>
  <div class="token-tracker">
    <div class="title">{{$t('tokenTracker.title')}}</div>
    <div class="section">
      <div class="col">
        <div class="num">{{totalToken}}</div>
        <div class="content">{{$t('tokenTracker.total')}}</div>
      </div>
      <div class="col">
        <div class="num">{{'+' + growth}}</div>
        <div class="content">{{$t('tokenTracker.growth')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      totalToken: 2131,
      growth: 24
    }
  }
}
</script>

<style lang="less" scoped>
@import url('./TokenTracker.less');
</style>